module.exports = __webpack_public_path__ + "img/symbol_1.06f6242f.png";